import { render } from "./TableNotif.vue?vue&type=template&id=5970c86c"
import script from "./TableNotif.vue?vue&type=script&lang=js"
export * from "./TableNotif.vue?vue&type=script&lang=js"

import "./TableNotif.vue?vue&type=style&index=0&id=5970c86c&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__